export const YEAR_GROUP_SELECTED = 'YEAR_GROUP_SELECTED';
export const ITEM_CATEGORY_SELECTED = 'ITEM_CATEGORY_SELECTED';
export const COUNTRY_SPEC_LOAD_SUCCESS = 'COUNTRY_SPEC_LOAD_SUCCESS';
export const ITEM_TYPE_SELECTED = 'ITEM_TYPE_SELECTED';
export const CLEAR_SELECTION = 'CLEAR_SELECTION';
export const FILTER_LIBRARY_ITEMS = 'FILTER_LIBRARY_ITEMS';

export function yearGroupSelected(payload) {
  return {
    type: YEAR_GROUP_SELECTED,
    yearGroupId: payload.target.value,
    checked: payload.target.checked
  };
}

export function itemTypeSelected(payload) {
    return {
        type: ITEM_TYPE_SELECTED,
        itemTypeId: payload.target.value,
        checked: payload.target.checked
    };
}

export function itemCategorySelected(payload) {
    return {
        type: ITEM_CATEGORY_SELECTED,
        itemCategoryId: payload.target.value,
        checked: payload.target.checked
    };
}

export function countrySpecLoadSuccess(payload) {
    return {
        type: 'COUNTRY_SPEC_LOAD_SUCCESS',
        value: payload
    };
}

export function clearSelection() {
    return {
        type: 'CLEAR_SELECTION'
    };
}

export function invokeFilter(payload) {
    return {
        type: 'FILTER_LIBRARY_ITEMS',
        filter: payload
    };
}

export function filterLibraryItems(searchTerm) {
    return (dispatch, getState) => {
        const state = getState();

        const yearGroups = state.filterReducer.yearGroups;
        const categories = state.filterReducer.itemCategories;
        const itemTypes = state.filterReducer.itemTypes;


        dispatch(invokeFilter({
            yearGroups,
            categories,
            itemTypes,
            searchTerm
        }));
    };
}

export function countrySpecLoadError(bool) {
    return {
        type: 'COUNTRY_SPEC_LOAD_ERROR',
        hasError: bool
    };
}

export function countrySpecLoading(bool) {
    return {
        type: COUNTRY_SPEC_LOAD_SUCCESS,
        isLoading: bool
    };
}

export function fetchCountrySpec() {
    return { type: 'FETCH_COUNTRY_SPEC' };
}
